import { render, staticRenderFns } from "./fileInfo.vue?vue&type=template&id=5950afee&scoped=true&"
import script from "./fileInfo.vue?vue&type=script&lang=js&"
export * from "./fileInfo.vue?vue&type=script&lang=js&"
import style0 from "./fileInfo.vue?vue&type=style&index=0&id=5950afee&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5950afee",
  null
  
)

export default component.exports